import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";

function CounterList() {
  const [counter, setCounter] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCounter();
  }, []);

  const loadCounter = async () => {
    try {
      const response = await api.get(
        "/Counter/GetCounter"
      );

      setCounter(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to load counter"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
 

      <div className="card shadow">

        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">
            Counter List
          </h4>
        </div>

        <div className="card-body">

          {loading ? (
            <div className="text-center">
              Loading...
            </div>
          ) : (

            <div className="table-responsive">

              <table className="table table-bordered table-striped">

                <thead className="table-dark">
                  <tr>
                    <th>ID</th>
                    <th>Counter Name</th>
                    <th>Prefix</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>

                  {counter.length > 0 ? (
                    counter.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.counterName}</td>
                        <td>{item.prefix}</td>
                        <td>
                          {item.isActive === true ? (
  <span className="badge bg-success">
  <i className="bi bi-eye-fill"></i>  Active
  </span>
) : (
  <span className="badge bg-danger">
   <i className="bi bi-eye-slash-fill"></i> Inactive
  </span>
)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center"
                      >
                        No Record Found
                      </td>
                    </tr>
                  )}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

  );
}

export default CounterList;